import * as Yup from 'yup';
import { countryCodes } from '@/domain/countries';

export default Yup.object().
  shape({
    firstname: Yup.string()
      .required('Este campo es requerido')
      .matches(/^[a-zA-Z0-9 ]+$/i, 'Solo se permiten valores alfanuméricos'),
    lastname: Yup.string()
      .required('Este campo es requerido')
      .matches(/^[a-zA-Z0-9 ]+$/i, 'Solo se permiten valores alfanuméricos'),
    company: Yup.string()
      .required('Este campo es requerido'),
    country: Yup.string()
      .required('Este campo es requerido')
      .oneOf(countryCodes(), 'Solo se permite un código de dos letras válido'),
    email: Yup.string()
      .email('Escriba una dirección de correo válida')
      .required('Este campo es requerido'),
    website: Yup.string()
      .notRequired()
  });
